// src/services/monitoringApi.js
// Thin wrapper around apiService for the Real-Time Monitoring endpoints.
import apiService from './apiService';

const monitoringApi = {
  listDevices: () => apiService.get('/monitoring/devices'),
  getLatest: (deviceId) => apiService.get(`/monitoring/devices/${deviceId}/latest`),
  getHistory: (deviceId, range = '24h') =>
    apiService.get(`/monitoring/devices/${deviceId}/history?range=${range}`),
  getAlerts: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return apiService.get(`/monitoring/alerts${qs ? `?${qs}` : ''}`);
  },
  // apiService (services/apiService.js) has no `patch` helper, so use the
  // generic request method to issue the PATCH.
  resolveAlert: (id) => apiService.request('patch', `/monitoring/alerts/${id}/resolve`, {}),
  generateHealthReport: (deviceId, range = '7d') =>
    apiService.post(`/monitoring/devices/${deviceId}/health-report`, { range }),
  listHealthReports: (deviceId) =>
    apiService.get(`/monitoring/devices/${deviceId}/health-reports`),
  getOverview: () => apiService.get('/monitoring/overview'),
};

export default monitoringApi;
